<app-traitement-data titre="SPO2 avec O2" [sousTitre]="patient!.tableauDeBord?.spo2AvecO2?.date | aLaDateDu"
    [statut]="patient!.tableauDeBord?.spo2AvecO2?.value ? 'info' : 'warning'">
    {{ patient!.tableauDeBord?.spo2AvecO2?.value ?? 'Pas de donnée' }}
</app-traitement-data>